import React from 'react';
import {Empty, Button, Col, Radio, Row, Select, Table, Typography} from "antd";
import FloatLabelNumberComponent from "./common/FloatLabelNumberComponent";
import FloatLabelInputComponent from "./common/FloatLabelInputComponent";
import utils from "../common/utils";
import {Translation} from "react-i18next";
import LoadingSvg from "./common/Loadingsvg";
import consts, {PREFIX_FRONT_URL} from "../consts";
import {debounce, isEmpty, map, get, find, values, first, chain} from 'lodash';
import {object, number, string} from 'yup';
import ConfirmModal from './modals/ConfirmModal';
import ModalAndLoadingAndValidateComponent from './common/ModalValidateLoadingComponent';
import login_saga from '../redux/sagas/login_saga';
import actions from '../redux/actions/setting_data';
import DisplayControl from './DisplayControl';

const {Text} = Typography;
const {Option} = Select;
const PERMISSION_LINK_SCREEN_TRANSFER_MONNEY = "/transaction/withdrawal";

class   TransferMoneyV2 extends ModalAndLoadingAndValidateComponent {
  
  columns = (t) => [
    {
      title: 'Tiền tệ',
      width: 250,
      dataIndex: 'currency',
      key: 'currency',
      render: this.getName,
    },
    {
      title: 'Số lượng',
      width: 150,
      dataIndex: 'amount',
      key: 'amount',
      render: (amount) => utils.formatCurrency(amount)
    },
    {
      title: 'Trạng thái',
      width: 100,
      dataIndex: 'status',
      key: 'status',
      render: (status) => t(utils.parseTranStatus(status)),
    },
    {
      title: 'Ngày rút',
      width: 200,
      dataIndex: 'created_at',
      key: 'created_at',
      render: (createdAt) => utils.formatTimeFromUnix(createdAt, 'DD/MM/YYYY HH:mm:ss'),
    },
  ]
  
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      params: {
        address: '',
        amount: 0,
      },
      searchText: '',
      gasPrice: 'FASTEST',
      value: '',
      coin: undefined,
      init: true,
    };
    
    this.useQuery = this.useQuery.bind(this);
  }
  
  componentDidMount() {
    if (!isEmpty(this.props.coins)) {
      const query = this.useQuery();
      this.handleChange(query.get("coin") || 'ETH');
    }
    this.fetchWithdrawalHistory(0, window.c.DEFAULT_PAGE_SIZE);
    this.props.fetchLimitWithdrawalAction({ pubkey: this.props.session.pubkey });
  }
  
  useQuery() {
    return new URLSearchParams(this.props.history.location.search);
  }
  
  withdrawal = debounce(() => {
    this.hideModal();
    this.enLoading();
    this.props.onWithdrawal({
      address: this.state.params.address,
      amount: this.state.params.amount,
      currency: this.state.coin.coin,
      contract: this.state.coin.contract_address,
      gas_price: this.state.gasPrice,
    }, () => {
      this.unLoading();
      this.setState({params: {}});
    })
  }, consts.DEFAULT_DURATION);
  
  fetchWithdrawalHistory(pos, count) {
    this.props.onFetchTransactionHistory({
        pos,
        count,
        trans_type: window.c.TRANSACTION_TYPE_WITHDRAW,
      },
    );
  }
  
  handleSearch = (searchText) => {
    this.setState({searchText});
  }
  
  UNSAFE_componentWillReceiveProps(nextProps, propsContext) {
    if (this.state.init && utils.hash(nextProps.coins || []) !== utils.hash(this.props.coins || [])) {
      console.log('=== componentWillReceiveProps === src/component/TransferMoneyV2.jsx:110');
      const query = this.useQuery();
      let coin = find(values(nextProps.coins), ['symbol', query.get("coin") || 'ETH']);
      this.handleChange(query.get("coin") || 'ETH', nextProps.coins);
      this.setState({init: false, coin});
    }
  }
  
  handleChange = (symbol = 'ETH', coins) => {
    if (!coins) {
      coins = this.props.coins
    }
  
    console.log(coins, ': coins src/component/TransferMoneyV2.jsx:123');
    let coin = find(values(coins), ['symbol', symbol]);
    this.setState({coin});
    this.props.fetchUserVolume24hAction({currency: get(coin, 'symbol', ''), contract: get(coin, 'contract', '')});
    this.clearErrors();
  }
  
  async validate() {
    const coinSymbol = get(this.state.coin, 'symbol', '');
    const mapLimitWithdrawals = get(this.props, 'mapLimitWithdrawals', {});
    let address = string().required().min(26).label('Địa chỉ');
    if (this.state.coin.type === consts.ETH || this.state.coin.type === consts.ERC_20) {
      address = address.test('isValidAddress', 'Địa chỉ không hợp lệ',
        (value) => `${get(this.props, `mapUserBalance.${this.state.coin.symbol}.blockchain_address`, '')}`.toLowerCase() !== `${value}`.toLowerCase())
        .test('isValidEth', 'Địa chỉ không hợp lệ', (value) => utils.isAddress(value));
    }
    
    const {coin: coinName} = this.state.coin;
    const balance = get(this.props.mapUserBalance[coinName], 'available_balance', 0);
    
    this.yupValidate = object().shape({
      address,
      amount: number().required().typeError("Số lượng phải là dạng số")
      .moreThan(0, "Số lượng phải lớn hơn 0")
      .max(mapLimitWithdrawals[coinSymbol]?.limit || 0 , `Số lượng phải ít hơn hoặc bằng ${utils.formatCurrency(mapLimitWithdrawals[coinSymbol]?.limit - this.props.limit24h) }` )
      .max(balance, 'Số dư của bạn không đủ')
      .test("isValidAmount", "Đồng đã đạt giới hạn chuyển", (value) => !!mapLimitWithdrawals[coinSymbol]?.limit)
      .label('Số lượng'),
    });
    
    return super.validate();
  }
  
  getName = (symbol) => {
    const {coins} = this.props;
    
    return <div className='d-flex'>
      <div style={{width: "65px", textAlign: "left"}}>
        <div style={{
          backgroundImage: `url(${coins[symbol]?.icon_image || ''})`, height: '26px',
          width: '26px',
          backgroundSize: 'contain',
          marginRight: "20px",
          display: 'block',
          backgroundRepeat: 'no-repeat',
          fontWeight: 600,
          color: 'black',
        }} alt={symbol} />
      </div>
      <div style={{width: "70px", textAlign: "left", fontWeight: "bold", lineHeight: '28px'}}>{symbol}</div>
      <div style={{
        width: "150px",
        textAlign: "left",
        fontSize: "12px",
        lineHeight: "28px",
        color: "#76808F",
      }}>{coins[symbol]?.name ?? ''}</div>
    </div>
  }
  
  render() {
    const {params, errors, isLoading} = this.state;
    const {limit24h, info, mapUserBalance, currencyMarkets, trans} = this.props;
    const coinSymbol = get(this.state.coin, 'symbol', '');
    const coin = get(this.state.coin, 'coin', '');
    const mapLimitWithdrawals = get(this.props, 'mapLimitWithdrawals', {});
    // console.log(mapLimitWithdrawals, ': mapLimitWithdrawals src/component/TransferMoneyV2.jsx:185');
    // let fee = get(limits, `${coin}:${info.security_level || 0}.fee`, 0);
    // let limit = get(this.props.limits, `${coin}:${this.props.info.security_level || 0}.limit`, 0);
    // let minimumWithdraw = get(limits, `${coin}:${info.security_level || 0}.minimum_withdrawal`, 0);
    // let volume24h = get(this.props.trans, `userVolume24h.${coin}`, 0);
    // let amountMustPay = params.amount + fee;
    // amountMustPay = amountMustPay > fee ? amountMustPay : 0;
    // console.log(this.props.trans, ': this.props.transaction src/component/TransferMoneyV2.jsx:182');

    const labelstyle = {
      boxSizing: "border-box",
      minWidth: 0,
      fontSize: '14px',
      color: '#76808f',
      fontWeight: '400',
      textAlign: 'left',
      paddingTop: '4px',
      paddingBottom: '4px',
      backgroundColor: 'inherit',
    };

    return (
      <Translation>
        {(t) => <div className="deposit-wrap p-medium">
          <h1 className="text-left">
          	Chuyển tiền
          </h1>
          <div className="left-deposit">
            <div className="text-left">
              {this.state.coin && <Select
                showSearch
                // placeholder="placeholder"
                defaultValue={<div>
                  <div style={{
                    display: 'block',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'contain',
                    height: '24px',
                    width: '24px',
                    backgroundImage: `url("${get(this.state.coin, 'icon_image', '')}")`,
                    float: "left"
                  }} className="mr-small mt-ex-small"/>
                  <div className="ln-normal pr-large">
                    {coinSymbol} {get(this.state.coin, 'name', '')}
                  </div>
                </div>}
                listItemHeight={30}
                style={{color: 'dark', width: '368px'}}
                defaultActiveFirstOption={true}
                showArrow={true}
                filterOption={false}
                onSearch={this.handleSearch}
                onChange={(value) => this.handleChange(value)}
                notFoundContent={null}
                size={"large"}
              >
                {chain(this.props.coins).values()
                  .filter(({symbol, name}) => `${symbol}${name}`.toLowerCase().includes(`${this.state.searchText}`.toLowerCase()))
                  .map((coin) => {
                    return <Option key={coin.symbol}>
                      <div style={{
                        display: 'block',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'contain',
                        height: '24px',
                        width: '24px',
                        backgroundImage: `url("${coin?.icon_image || ''}")`,
                        float: "left"
                      }} className="mr-small mt-ex-small"/>
                      <div className="ln-normal pr-large">
                        {coin.symbol} {coin.name}
                      </div>
                    </Option>
                  }).value()}
              </Select>}
            </div>
          </div>
          
          <Row  className="box-shadow text-left mb-small">
            <Col span={12}>
              <div className="d-flex direct-column">
                <div className="label mr-small">
                  Tổng số dư:
                </div>
                <div className="value fz-32">
                  {utils.formatCurrency(get(mapUserBalance, [coin, 'balance'], '0.00000000'))} {coinSymbol}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className="d-flex direct-column">
                <div className="label mr-small">
                  Số dư có sẵn:
                </div>
                <div className="value fz-32">
                  {utils.formatCurrency(get(mapUserBalance, [coin, 'available_balance'], '0.00000000'))} {coinSymbol}
                </div>
              </div>
            </Col>
          </Row>
          <Row  className="box-shadow text-left mb-small">
            <Col span={12} className="">
              <div className="text-left p-medium pr-large">
                <div className='mb-medium' >
                  <p className='text-normal fontW-700'>Mẹo</p>
                  <div className="op-80 d-flex align-items text-normal mb-small">
                    <div className="icon-gridicons_checkmark icon-checkmark" />
                    <div>Đồng sẽ được gửi sau 1 lần xác nhận mạng.</div>
                  </div>
                  <div className="op-80 d-flex align-items text-normal mb-small">
                    <div className="icon-gridicons_checkmark icon-checkmark" />
                    <div>Cho đến khi 2 xác nhận được thực hiện, một lượng tài sản tương đương của bạn sẽ tạm thời không có sẵn để rút tiền.</div>
                  </div>
                </div>
                <div>
                  <p className='text-normal fontW-700'>{`Chỉ gửi ${coinSymbol} tới các địa chỉ nhận tiền.`}</p>
                  <div className="op-80 d-flex align-items text-normal mb-small">
                    <div className="icon-gridicons_checkmark icon-checkmark" />
                    <div>{`Gửi đồng hoặc token khác ngoài ${coinSymbol} tới địa chỉ ${coinSymbol} có thể dẫn tới mất số tiền mà bạn vào địa chỉ trên`}</div>
                  </div>
                </div>
              </div>
            </Col>

            <Col span={12}>
              <div className="right-deposit address mt-medium">
                <div className="pb-small">
                  <FloatLabelInputComponent
                    label={`Địa chỉ ${coinSymbol} của người nhận:`}
                    transform="scale(1) translate(0, -50%)"
                    className='default-input'
                    labelstyle={labelstyle}
                    value={params.address}
                    overrideFocus={this.clearErrors}
                    onChange={({target}) => this.setState({params: {...params, address: target.value.trim()}})}/>
                  <div className="text-left p-abs no-wrap">
                    <Text type='danger'>{utils.upperCaseFirst(errors.address || '')}</Text>
                  </div>
                </div>
                <div className="pt-medium mt-small">
                  <FloatLabelNumberComponent
                    labelstyle={labelstyle}
                    className="w-100 default-input"
                    transform="scale(1) translate(0, -88%)"
                    label='Số lượng'
                    min={0}
                    suffixLength={`${coinSymbol}`.length}
                    suffix={<div className="text-black">{coinSymbol}</div>}
                    value={params.amount}
                    overrideFocus={this.clearErrors}
                    onChange={(amount) => this.setState({params: {...params, amount}})}/>
                  <div className="text-left p-abs no-wrap">
                    <Text type='danger'>{utils.upperCaseFirst(errors.amount || '')}</Text>
                  </div>
                </div>
                <div className="fll pt-medium pb-medium lh-medium bold ls-medium">
                  Hạn mức chuyển tiền mỗi ngày: { limit24h || 0 } / {utils.formatCurrency(mapLimitWithdrawals[coinSymbol]?.limit || 0 )} {coinSymbol}
                </div>
                {
                  get(this.state.coin, 'type', '') === window.c.ERC_20 || window.c.ETH ?
                    <>
                      <div className="pt-medium pb-medium flr clearfix bold button-1">
                        <Radio.Group value={this.state.gasPrice}
                                     onChange={({target}) => this.setState({gasPrice: target.value})}>
                          <Radio.Button value="AVERAGE">Trung bình</Radio.Button>
                          <Radio.Button value="FAST">Nhanh</Radio.Button>
                          <Radio.Button value="FASTEST">Siêu nhanh</Radio.Button>
                        </Radio.Group>
                      </div>
                    </> : ''
                }
              </div>
              
             <DisplayControl permission_link_screen={consts.AUTH.TRANSACTION__WITHDRAWAL} action={consts.CONTROLS.POST}>
             <div className="btn-controls mt-small">
                <Button size={"large"} className="btn-min-width w-100 br-5 text-center"
                        style={{   background: "rgba(196, 196, 196, 0.5)", borderRadius: 5}}
                        onClick={this.showModal}
                        disabled={isLoading}
                        icon={<LoadingSvg name='bars_primary' color={consts.PRIMARY_COLOR}
                                          hidden={!isLoading} size={25}/>}
                >
                  <span className="bold px-small">{!isLoading && 'Đồng ý gửi'}</span>
                </Button>
              </div>
             </DisplayControl>
            </Col>
          </Row>
          
          <div className="deposit-bottom mt-medium">
            <h2 className="text-left">Lịch sử chuyển gần nhất</h2>
            <Table columns={this.columns(t)}
                   locale={{emptyText: (<Empty description={<span className="bold">Trống</span>} />)}}
                   className="mw-800"
                   dataSource={get(this.props.transaction, 'trans', [])}
                   pagination={{
                     defaultPageSize: window.c.DEFAULT_PAGE_SIZE,
                     total: get(this.props.transaction, 'totalCount', 0),
                     onChange: (page, pageSize) => {
                       this.fetchWithdrawalHistory((page - 1) * pageSize, pageSize)
                     },
                     hideOnSinglePage: true,
                     responsive: true,
                   }}
            />
          </div>
            <ConfirmModal
              title={'Thông báo'}
              okText={'Xác nhận'}
              okType={'primary'}
              cancelText={'Hủy'}
              onConfirm={this.withdrawal}
              onCancel={this.hideModal}
              isVisible={this.state.isVisible}>
              <div>
                Bạn có chắc muốn thực hiện giao dịch không?
              </div>
            </ConfirmModal>
          
        </div>}
      </Translation>
    );
  }
}

export default TransferMoneyV2;
